module.exports = {
    "Clear search": `Aramay\u{131} temizle`
};


//# sourceMappingURL=tr-TR.main.js.map
